/**
 * table表头
 */

import arrayUtils from '../../../static/js/arrayUtils'
import cellSort from './cellSort'
import cellBatchModify from './cellBatchModify.vue'
import { PgTextTip } from 'pangu-components-plus'
export default {
  name: 'editCellHeader',
  components: {
    cellSort,
    cellBatchModify,
  },
  props: {
    column: {
      type: Object,
      default: () => {},
    },
    tableColumnDefData: {
      type: Object,
      default: () => {},
    },
    // 完整tableData,用于表头过滤
    tableDataOfAll: {
      type: Array,
      default: () => {
        return []
      },
    },
    //是否显示排序,前端分页表格目前不支持排序,暂时用变量控制
    sort: {
      type: Boolean,
      default: true,
    },
    draggableOfHeader: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Array],
      default: () => [],
    },
    defaultSortVal: {
      type: [Array],
      default: null,
    },
    store: Object,
    extendData: Object,
    disabled: Boolean,
    batchRow: Function,
  },
  watch: {
    value(val) {
      this.data = val
    },
  },
  data() {
    return {
      data: this.value,
      dataForFilterGroup: {},
    }
  },
  methods: {
    getFilterGroup(data) {
      if (data.length <= 0) return
      for (let key in data) {
        this.dataForFilterGroup[key] = data[key]
      }
    },
  },
  render(h) {
    var formItems = this.tableColumnDefData.items
    var item = arrayUtils.getArrayItemByTwoFieldValue(
      formItems,
      'property',
      this.column.property,
      'label',
      this.column.label
    )

    // 添加 <span> 用于显示表头 label
    var elementSpanClass = ['pangu-table_header-item']
    // let rules = item.validators;
    // if (!item.required  && rules && rules.length) {
    //     rules.every(rule => {
    //         if (rule.required) {
    //             item.required=true;
    //             return false;
    //         }
    //     });
    // }

    if (item.required) {
      elementSpanClass.push('pangu-table_header-item-required')
    }

    let childrenArr = []
    if (item.filter) {
      // 暂时屏蔽表头过滤功能 为了保持UI界面体验统一，UX认为现阶段意义已经不大
      /* let _elementHeaderFilter = h(
                      'filterOfTableHeader', {
                          props: {
                              'label': item.label,
                              'property': item.property,
                              'tableData': this.data,
                              'tableDataOfAll': this.tableDataOfAll
                          },
                          on: {
                              'on-souce': (keyForNeedReset) => {
                                  this.$emit('on-souce', keyForNeedReset, this.dataForFilterGroup);
                              },
                              'get-checkbox-group-data': (data) => {
                                  this.getFilterGroup(data);
                              }
                          }
                      }
                  );
                  childrenArr = [_elementHeaderFilter]; */
      childrenArr.push(item.label)
    } else {
      childrenArr.push(
        item.label,
        h(PgTextTip, {
          props: {
            text: item.title,
          },
        })
      )
    }

    // 支持多列排序,由于element 只支持单列排序,因此,自定义排序组件
    //ascOrder: 是否升序 true : false
    // sort: 是否排序
    if (this.sort && item.sort) {
      let defaultSortValField = [] // 外部传入的默认排序规则的field数组
      if (this.defaultSortVal) defaultSortValField = this.defaultSortVal.map((im) => im.field)
      let index = defaultSortValField.indexOf(item.order || item.property) // 当前表头,是否在默认排序列
      //当前列的排序规则,true 升序 false 降序
      // [
      //     {
      //         "label": "不排序",
      //         "value": ""
      //     },
      //     {
      //         "label": "升序",
      //         "value": "true"
      //     },
      //     {
      //         "label": "降序",
      //         "value": "false"
      //     }
      // ]
      let ascO = item.ascOrder
      if (~index) {
        ascO = this.defaultSortVal[index].order
      }
      childrenArr.push(
        h('cellSort', {
          props: {
            value: ascO,
          },
          on: {
            input: (value) => {
              this.$emit('sort-change', value)
            },
          },
        })
      )
    }

    if (item.batchModify) {
      // item.batchModify
      childrenArr.push(
        h('cellBatchModify', {
          props: {
            item,
            store: this.store,
            extendData: this.extendData,
            disabled: this.disabled,
            batchRow: this.batchRow,
            tableData: this.value,
          },
        })
      )
    }

    // .el-table th div 会给div全部line-height: 40px 故换成span
    var elementSpan = h(
      'span',
      {
        class: elementSpanClass,
      },
      childrenArr
    )
    // fixed 左右固定不允许拖拽
    if (item.fixed || !this.draggableOfHeader) {
      return elementSpan
    }

    let _draggableContainer = h(
      'draggableContainer',
      {
        class: ['thead-cell'],
        props: {
          visible: item.visible,
          data: item,
        },
        on: {
          drop: (fromToData) => {
            var formItems = this.tableColumnDefData.items
            var fromIndex = arrayUtils.getArrayItemByTwoFieldValue(
              formItems,
              'property',
              fromToData.from.property,
              'label',
              fromToData.from.label
            )
            var toIndex = arrayUtils.getArrayItemByTwoFieldValue(
              formItems,
              'property',
              fromToData.to.property,
              'label',
              fromToData.from.label
            )

            if (fromIndex < 0 || toIndex < 0) {
              if (this.GLOBAL.isDebug)
                console.log(
                  'changeItem,from,to,fromIndex,toIndex',
                  fromToData,
                  fromIndex,
                  toIndex,
                  formItems
                )
              alert('异常错误')
              return
            }

            if (this.GLOBAL.isDebug)
              console.log(
                'changeItem,from,to,fromIndex,toIndex',
                fromToData,
                fromIndex,
                toIndex,
                this.tableColumnDefData
              )
          },
          click: () => {
            // this.handlerClick(value)
          },
          dblclick: () => {},
        },
      },
      [elementSpan]
    )
    return _draggableContainer
  },
}
